import React, { useEffect, useState } from 'react';
import {
  showPromptPush,
  addPermissionListener,
  getSubscriptionStatus,
  removePermissionListener,
} from 'v2/utils/pushNotification';
import styles from './webNotificationsSettings.module.scss';

type WebNotificationsSettingsProps = {
  disabled: boolean;
};

export const WebNotificationsSettings = ({
  disabled,
}: WebNotificationsSettingsProps) => {
  const [webNotificationsStatus, setWebNotificationsStatus] =
    useState<boolean>(false);
  const [isListenerAdded, setIsListenerAdded] = useState(false);

  const getWebNotificationsStatus = async () => {
    const status = await getSubscriptionStatus();
    setWebNotificationsStatus(status !== undefined ? status : false);
  };

  useEffect(() => {
    getWebNotificationsStatus();
  }, []);

  const eventPermissionListener = async (permission: boolean) => {
    if (permission) {
      setWebNotificationsStatus(true);
    }
  };
  const removeListener = () => {
    if (isListenerAdded) {
      removePermissionListener(eventPermissionListener);
      setIsListenerAdded(false);
    }
  };

  useEffect(() => {
    removeListener();
  }, [webNotificationsStatus]);

  const permissionChangeListener = () => {
    addPermissionListener(eventPermissionListener);
    setIsListenerAdded(true);
  };
  const openPrompt = async () => {
    await showPromptPush();
    permissionChangeListener();
  };

  return (
    <div data-testid="webNotifications">
      <label>Web Notifications</label>
      <p className={styles.WebNotificationsText}>
        Your web notifications are set to:{' '}
        {webNotificationsStatus ? 'ON' : 'OFF'}
      </p>
      {webNotificationsStatus === false && (
        <button
          disabled={disabled}
          className={styles.promptButton}
          onClick={openPrompt}
        >
          Change this
        </button>
      )}
    </div>
  );
};
